import { render, staticRenderFns } from "./RequestBug.vue?vue&type=template&id=2823138a&"
import script from "./RequestBug.vue?vue&type=script&lang=js&"
export * from "./RequestBug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports